import React, { useState, useEffect } from 'react';
import { FaInstagram, FaWhatsapp, FaPhone, FaEnvelope, FaYoutube, FaFileAlt, FaCross } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import apiClient from '../../api/client'; // Import apiClient
import packageInfo from '../../../package.json';
import { FaRadio } from 'react-icons/fa6';

const Footer = () => {
    const [pendetaList, setPendetaList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPendeta = async () => {
            try {
                const data = await apiClient.getPendetaList();
                setPendetaList(data);
            } catch (err) {
                setError('Gagal memuat data pendeta.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchPendeta();
    }, []);

    return (
        <footer className="bg-gray-900 text-gray-300 py-4">
            <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                {/* Kolom 1: PENDETA */}
                <div className="flex flex-col space-y-4">
                    <h3 className="text-xl font-bold text-white mb-4">PENDETA</h3>
                    {isLoading ? (
                        <p>Memuat data...</p>
                    ) : error ? (
                        <p className="text-red-400">{error}</p>
                    ) : pendetaList.length > 0 ? (
                        pendetaList.map((pendeta, index) => (
                            <div key={index}>
                                <p className="font-semibold text-white">{pendeta.name}</p>
                                <p className="text-sm italic text-gray-400">[{pendeta.jabatan}]</p>
                            </div>
                        ))
                    ) : (
                        <p>Tidak ada data pendeta.</p>
                    )}
                </div>

                {/* Kolom 2: HUBUNGI KAMI & SIARAN RADIO */}
                <div className="flex flex-col space-y-6">
                    <div>
                        <h3 className="text-xl font-bold text-white mb-4">HUBUNGI KAMI</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center space-x-3">
                                <FaInstagram className="text-lg text-pink-500" />
                                <a href="https://www.instagram.com/inforkom.kakaba/" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">INSTAGRAM</a>
                            </li>
                            <li className="flex items-center space-x-3">
                                <FaWhatsapp className="text-lg text-green-500" />
                                <a href="https://wa.me/6282247231915" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">WHATSAPP</a>
                            </li>
                            <li className="flex items-center space-x-3">
                                <FaPhone className="text-lg text-blue-500" />
                                <a href="tel:+6282247231915" className="hover:text-white transition-colors">PHONE</a>
                            </li>
                            <li className="flex items-center space-x-3">
                                <FaEnvelope className="text-lg text-red-500" />
                                <a href="mailto:kasihkarunia.denpasar@gpib.or.id" className="hover:text-white transition-colors">EMAIL</a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-xl font-bold text-white mb-4">INFORMASI GPIB</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center space-x-3">
                                <FaYoutube className="text-lg text-red-500" />
                                <a href="https://www.youtube.com/@gpibkasihkaruniabadungbali" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">YOUTUBE</a>
                            </li>
                            <li className="flex items-center space-x-3">
                                <FaFileAlt className="text-lg text-blue-400" />
                                <Link to="/warta-jemaat" className="hover:text-white transition-colors">WARTA JEMAAT</Link>
                            </li>
                            <li className="flex items-center space-x-3">
                                <FaCross className="text-lg text-gray-400" />
                                <Link to="/berita-duka" className="hover:text-white transition-colors">BERITA DUKA</Link>
                            </li>
                            <li className="flex items-center space-x-3">
                                <FaRadio className="text-lg text-gray-400" />
                                <Link to="https://a1.siar.us/public/gpibvoice" className="hover:text-white transition-colors">SIARAN RADIO GPIB</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Kolom 3: ALAMAT & PETA */}
                <div>
                    <h3 className="text-xl font-bold text-white mb-4">ALAMAT</h3>
                    <div className="bg-gray-800 rounded-lg overflow-hidden h-48">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d986.207681657615!2d115.178935!3d-8.612245!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2dd2397b04463cfb%3A0x16454087b97aefba!2sYayasan%20Panji%20Kasih%20Karunia!5e0!3m2!1sid!2sid!4v1754974259623!5m2!1sid!2sid"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Maps Location"
                        ></iframe>
                    </div>
                    <p className="text-sm mt-4">Gedung Yayasan Panji Kasih Karunia:</p>
                    <p className="text-sm">Jl. Panji No. 23A, Kwanji, Dalung, Kuta Utara, Badung Bali</p>
                </div>
            </div>

            {/* Bagian Bawah Footer */}
            <div className="border-t border-gray-700 mt-4 pt-2 text-center text-sm text-white-500">
                <p className="mt-0">
                    ver. {packageInfo.version} | {new Date().getFullYear()} | Copyright © INFORKOM GPIB KASIH KARUNIA BADUNG - BALI
                </p>
            </div>
        </footer>
    );
};

export default Footer;